<template>
  <div>
    <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="$tx('hygl.components.ytRecord', '议题纪要')" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
      <div>
        <el-input v-model="currentRow.resolution" type="textarea" :autosize="{ minRows: 5 }" :placeholder="$tx('hygl.components.pleaseIput', '请输入内容')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'cancel'" @click="toClose">取 消</el-button>
        <el-button v-pageBtn-lbl="'save'" type="primary" @click="submitHandle">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="viewdialogVisible" :title="$tx('hygl.components.meetingAgenda', '会议议题')" :visible.sync="viewdialogVisible" width="1000px" :close-on-click-modal="false" :before-close="handleClose">
      <div>
        <el-form ref="receiveForm" :model="receiveObj">
          <div class="el-table el-table--fit el-table--border" style="width: 100%">
            <div class="el-table__body-wrapper">
              <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                <tbody>
                  <template>
                    <tr>
                      <td ref="tdlbl_时间 " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'hyyt'">会议议题</span>
                      </td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                        {{ vo.subject }}
                      </td>
                    </tr>

                    <tr>
                      <td ref="tdlbl_值班领导  " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'meetingTypeName'">会议类型</span>
                      </td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ vo.subjectTypeName }}
                      </td>
                      <td ref="tdlbl_值班领导  " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'mainDept'">主办部门</span>
                      </td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ vo.mainDept }}
                      </td>
                    </tr>
                    <tr>
                      <td ref="tdlbl_值班领导  " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'reportTime'">陈述时间（分钟）</span>
                      </td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ vo.reportTime }}
                      </td>
                      <td ref="tdlbl_值班领导  " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'talkTime'">讨论时间（分钟）</span>
                      </td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ vo.talkTime }}
                      </td>
                    </tr>
                    <tr>
                      <td ref="tdlbl_值班领导  " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'reportPersonName'">陈述人</span>
                      </td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ vo.reportPersonName }}
                      </td>
                      <td ref="tdlbl_值班领导  " v-field-lbl="'isPpt'" class="el-table__cell tdlbl tdw17" colspan="1">是否ppt演示</td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ formatstatus(vo.isPpt) }}
                      </td>
                    </tr>
                    <tr>
                      <td ref="tdlbl_值班领导  " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'isAttendDept'">相关部门列席</span>
                      </td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ formatstatus(vo.isAttendDept) }}
                      </td>
                      <td ref="tdlbl_值班领导  " v-field-lbl="'isWritten'" class="el-table__cell tdlbl tdw17" colspan="1">携带纸质材料</td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        {{ formatstatus(vo.isWritten) }}
                      </td>
                    </tr>

                    <tr>
                      <td ref="tdlbl_时间 " v-field-lbl="'attendStoolName'" class="el-table__cell tdlbl tdw17" colspan="1">随议题列席人员</td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                        {{ vo.attendStoolName }}
                      </td>
                    </tr>
                    <tr>
                      <td ref="tdlbl_时间 " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'resolution'">决策建议</span>
                      </td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                        {{ vo.resolution }}
                      </td>
                    </tr>
                    <tr>
                      <td ref="tdlbl_时间 " v-field-lbl="'remark'" class="el-table__cell tdlbl tdw17" colspan="1">备注</td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                        {{ vo.remark }}
                      </td>
                    </tr>
                    <tr>
                      <td ref="tdlbl_附件" v-field-lbl="'attach'" class="el-table__cell tdlbl tdw17">附件</td>
                      <td class="el-table__cell tdcont tdcont" colspan="5">
                        <Attachment ref="attachments" wf-attach-url="hygl/hyapYtInfo" :vo="vo" :is-required="0" accept="*.*" empty-message="" :limit-count="10" online-editor="" online-file="" :attachments="vo.passenger.attachments" :attachs-type="'ATTACH'" />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'close'" @click="viewdialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="dialogMeetVisible" v-el-drag-dialog :title="$tx('hygl.components.ytRecord', '议题纪要')" :visible.sync="dialogMeetVisible" width="900px" :close-on-click-modal="false" :destroy-on-close="true">
      <div>
        <el-form ref="hyapYtInfo" :model="hyapYtInfo">
            <div class="el-table el-table--fit el-table--border inner-table">
              <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                  <tbody>

                    <tr>
                      <td class="el-table__cell tdlbl tdw17" colspan="1"><span class="required">*</span>会议议题</td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="会议议题" rules="required">
                          <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                            <el-input v-model="hyapYtInfo.subject" name="subject" placeholder="请输入会议议题" />
                          </el-tooltip>
                        </ValidationProvider>
                      </td>
                    </tr>
                    <tr>
                      <td class="el-table__cell tdlbl tdw17" colspan="1"><span class="required">*</span>陈述人</td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                         <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="陈述人" rules="required">
                          <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                            <el-input v-model="hyapYtInfo.reportPersonName" v-select-dialog="'staff'" readonly multiple="false" name="reportPersonName" placeholder="请选择陈述人" />
                          </el-tooltip>
                        </ValidationProvider>
                      </td>
                      <td class="el-table__cell tdlbl tdw17" colspan="1"><span class="required">*</span>主办部门</td>
                      <td class="el-table__cell tdcont tdw33" colspan="2">
                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="主办部门" rules="required">
                          <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                            <el-input v-model="hyapYtInfo.mainDept" v-select-dialog="'suborg'" org-level="2" readonly dialog-title="选择主办部门" multiple="false" name="mainDept" placeholder="请选择主办部门" />
                          </el-tooltip>
                        </ValidationProvider>
                      </td>
                    </tr>
                    <tr>
                      <td class="el-table__cell tdlbl tdw17" colspan="1"><span class="required">*</span>议题纪要</td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                              <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="主办部门" rules="required">
                              <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-input v-model="hyapYtInfo.resolution" type="textarea" autosize name="flContent" placeholder="请输入议题纪要" />
                              </el-tooltip>
                            </ValidationProvider>
                      </td>
                    </tr>
                    <tr v-if="hyapYtInfo.id">
                      <td class="el-table__cell tdlbl tdw17" colspan="1"><span class="required">*</span>议题纪要</td>
                      <td class="el-table__cell tdcont tdw83" colspan="5">
                           <Attachment ref="hyjyAttachments" :vo="hyapYtInfo" accept="*.*" empty-message="" wf-attach-url="/hygl/hyapYtInfo" :limit-count="10" online-editor="" online-file="" :attachments="hyapYtInfo.passenger.attachments" :attachs-type="'ATTACH'" :is-drag="0" :auto-upload="0" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'cancel'" @click="toClose">取 消</el-button>
        <el-button v-pageBtn-lbl="'save'" type="primary" @click="submiMeetHandle">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    filters: {},
    props: {
        wfInstance: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            i18npkg: 'hygl',
            moduleCode: 'hyap',
            dialogVisible: false,
            dialogMeetVisible: false,
            meetingMinutes: '',
            currentRow: '', // 当前行数据
            callbackFn: null,
            formType: false, // false表示list弹窗，需要调接口更新，true表示流程弹窗，不需要调接口更新
            vo: {},
            viewdialogVisible: false,
            hyapYtInfo: {},
            canEdit: 1
        }
    },
    create() {
        this.$bus.on('openView', this.getdata)
        this.$bus.on('openSummaryDialog', this.openSummaryDialog)
        this.$bus.on('openMeetJyapDialog', this.openMeetJyapDialog)
    },
    beforeDestroy() {
        this.$bus.off('openView', this.getdata)
        this.$bus.off('openSummaryDialog', this.openSummaryDialog)
        this.$bus.off('openMeetJyapDialog', this.openMeetJyapDialog)
    },
    methods: {
        formatstatus(val) {
            if (val == 0) {
                return this.$tx('hygl.common.no', '否')
            } else {
                return this.$tx('hygl.common.yes', '是')
            }
        },
        getdata(vo) {
            this.vo = vo
            this.viewdialogVisible = true
        },
        openSummaryDialog(row, type = false, all = false, callback = null) {
            this.currentRow = row
            this.formType = type
            this.callbackFn = callback
            this.dialogVisible = true
        },
        openMeetJyapDialog(vo, callback = null) {
            this.vo = vo
            this.callbackFn = callback
            this.getHyapYtInfo()
            this.dialogMeetVisible = true
        },
        getHyapYtInfo() {
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/hygl/ytRecord/addNew`,
                method: 'POST'
            }).then((res) => {
                if (res.code === 'success') {
                    this.hyapYtInfo = res.body.vo
                    this.hyapYtInfo.hyapId = this.vo.meetingId
                    var dept = this.loginUser.staffList[0].orgFullName.split('-')
                    this.hyapYtInfo.creator = this.loginUser.personName
                    this.hyapYtInfo.creatorId = this.loginUser.personId
                    this.hyapYtInfo.passenger.meetingMinutes = ''
                    this.hyapYtInfo.createDept = dept[dept.length - 1]
                    this.hyapYtInfo.status = 1
                    this.hyapYtInfo.subjectTypeName = this.vo.meetingTypeName
                    this.hyapYtInfo.subjectType = this.vo.meetingTypeId

                    if (this.hyapYtInfo.passenger.attachments) this.$set(this.hyapYtInfo.passenger, 'attachments', [])
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        submiMeetHandle() {
            this.$refs.hyapYtInfo.formValidate(() => {
                this.hyapYtInfo.passenger.meetingMinutes = this.hyapYtInfo.resolution
                var fileList = this.$refs.hyjyAttachments.uploadAttach
                if (fileList.length > 0) {
                    fileList.forEach((item) => {
                        this.$set(item, 'busiDataId', this.hyapYtInfo.id)
                    })
                }
                this.hyapYtInfo.passenger.uploadAttach = fileList
                console.log('this.hyapYtInfo', this.hyapYtInfo)
                if (this.callbackFn !== null) {
                    this.callbackFn(this.hyapYtInfo)
                }
                this.dialogMeetVisible = false
                // this.$http({
                //     contentType: 'application/x-www-form-urlencoded',
                //     url: `/hygl/hyapYtInfo/insert`,
                //     method: 'POST',
                //     data: this.hyapYtInfo
                // }).then((res) => {
                //     if (res.code === 'success') {
                //         this.$message.success(res.message)
                //         if (this.callbackFn !== null) {
                //             this.callbackFn(this.hyapYtInfo)
                //         }
                //         this.dialogMeetVisible = false
                //     } else {
                //         this.$message.error(res.message)
                //     }
                // })
            }, null, 1)
        },
        toClose() {
            this.dialogVisible = false
            this.meetingMinutes = ''
            this.callbackFn = null
            this.viewdialogVisible = false
            this.dialogMeetVisible = false
        },
        submitHandle() {
            if (this.formType) {
                this.toClose()
                if (this.callbackFn !== null) {
                    this.callbackFn(this.currentRow.resolution)
                }
            } else {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/hygl/ytRecord/update`,
                    method: 'put',
                    data: this.currentRow
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        if (this.callbackFn !== null) {
                            this.callbackFn(this.currentRow.resolution)
                        }
                        this.toClose()
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let id = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                if (id !== '') id += ','
                selected += node.name
                id += node.personId
            })
            this.forceUpdate = true
            this.$set(this.hyapYtInfo, 'reportPersonName', selected)
            this.$set(this.hyapYtInfo, 'reportPerson', id)
            this.$nextTick(() => {
                this.forceUpdate = false
                this.$forceUpdate()
            })
        },
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let id = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                if (id !== '') id += ','
                selected += node.name
                id += node.id
            })
            this.forceUpdate = true
            this.$set(this.hyapYtInfo, 'mainDept', selected)
            this.$set(this.hyapYtInfo, 'mainDeptId', id)
            this.$nextTick(() => {
                this.forceUpdate = false
                this.$forceUpdate()
            })
        }
    }
}
</script>

<style>
</style>
